// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Style_navBar__223FE","navOptions":"Style_navOptions__2vX42","CircleBtn":"Style_CircleBtn__27Zw6","active":"Style_active__2Enkw","OFFBtn":"Style_OFFBtn__1osaO"};